import React from "react";

const Shipping = ({ color = "#232323" }) => {
  return (
    <svg
      id="Raggruppa_1211"
      data-name="Raggruppa 1211"
      width="31"
      height="17"
      viewBox="0 0 31 17"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rettangolo_566"
            data-name="Rettangolo 566"
            width="31"
            height="17"
            fill="none"
            stroke={color}
            stroke-width="1"
          />
        </clipPath>
      </defs>
      <g
        id="Raggruppa_1210"
        data-name="Raggruppa 1210"
        clip-path="url(#clip-path)"
      >
        <path
          id="Tracciato_311"
          data-name="Tracciato 311"
          d="M22.44.5V14.1H12.78a2.42,2.42,0,0,0-4.83,0H5.5V.5Z"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Tracciato_312"
          data-name="Tracciato 312"
          d="M30.5,9.3v4.8H28.89a2.42,2.42,0,0,0-4.83,0H22.44V4.5h3.37Z"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Tracciato_313"
          data-name="Tracciato 313"
          d="M30.5,9.3v4.8H28.89a2.42,2.42,0,0,0-4.83,0H22.44V9.3Z"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <ellipse
          id="Ellisse_45"
          data-name="Ellisse 45"
          cx="2.42"
          cy="2.4"
          rx="2.42"
          ry="2.4"
          transform="translate(7.94 11.7)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <ellipse
          id="Ellisse_46"
          data-name="Ellisse 46"
          cx="2.42"
          cy="2.4"
          rx="2.42"
          ry="2.4"
          transform="translate(24.05 11.7)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Linea_266"
          data-name="Linea 266"
          x2="2.61"
          transform="translate(0.5 2.1)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Linea_267"
          data-name="Linea 267"
          x2="2.61"
          transform="translate(0.5 5.3)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Linea_268"
          data-name="Linea 268"
          x2="2.61"
          transform="translate(0.5 8.5)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
      </g>
    </svg>
  );
};

export default Shipping;
